import axios from "axios";
import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import connection from "./connection";
import { RequestFormDto } from "../../../../shared-models/vms/src/lib/request-form/request.dto";
import { RequestReport } from "../../../../shared-models/vms/src/lib/request-form/report.dto";
import { CommonResponse } from "@gtpl/shared-models/masters";
import { RequestById } from '../../../../shared-models/vms/src/lib/request-form/request.request';
import { VisitorDto } from "../../../../shared-models/vms/src/lib/request-form/security.dto";
import { RequestByName } from "../../../../shared-models/vms/src/lib/request-form/request.name"

export class RequestService {

    URL = connection.DEPLOY_URL + '/request';

    async createRequest(createDto: RequestFormDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/createRequest',createDto)
        .then(res=>{
            return res.data;
        })
    }

    async getAllRequests(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllRequests')
        .then(res=>{
            return res.data;
        })
    }

    async updateStatusHod(updateHodReq:RequestFormDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/updateStatusHod',updateHodReq)
        .then(res=>{
            return res.data;
        })
    }

    async getHodApprovedRequests(req:RequestReport): Promise<CommonResponse> {
        
        return await axios.post(this.URL + '/getHodApprovedRequests',req)
        .then(res=>{
            console.log(res.data,"response")
            return res.data;
        })
    }

    async updateStatusHr(updatestatusHrDto: RequestFormDto): Promise<GlobalResponseObject> {
        return await axios.post(this.URL + '/updateStatusHr', updatestatusHrDto)
        .then(res => {
            return res.data;
        })
    }

    async getPassById(id: number): Promise<CommonResponse> {
        return await axios.get(this.URL + `/${id}`)
        .then(res => {
            return res.data;
        })
    }

    async getRequestById(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRequestById')
        .then(res => {
            return res.data;
        })
    }

    async getById(requestDto: RequestById): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getById',requestDto)
        .then(res => {
            return res.data;
        })
    }

    async getRequestByName(requestDto: RequestFormDto): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getRequestByName',requestDto)
        .then(res => {
            return res.data;
        })
    }

    async updateRequest(updateDto: RequestFormDto): Promise<GlobalResponseObject> {
        return await axios.post(this.URL + '/updateRequest', updateDto)
        .then(res => {
            return res.data;
        })
    }

    async getReport(reportDto: RequestReport): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReport', reportDto)
        .then(res => {
            return res.data;
        })
    }

    async createCheckIn(createDto: VisitorDto): Promise<GlobalResponseObject> {
        return await axios.post(this.URL + '/createCheckIn',createDto)
        .then(res=>{
            return res.data;
        })
    }

    async updateCheckOut(updateDto: VisitorDto): Promise<GlobalResponseObject> {
        return await axios.post(this.URL + '/updateCheckOut', updateDto)
        .then(res => {
            return res.data;
        })
    }

    async getAllCheckIn(req: RequestById): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllCheckIn',req)
        .then(res=>{
            return res.data;
        })
    }

    async getAllCheckInReport(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getAllCheckInReport')
        .then(res=>{
            return res.data;
        })
    }

    async getReqIdPreviewData(req: RequestById): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getReqIdPreviewData',req)
        .then(res=>{
            return res.data;
        })
    }
    
    async getExpiredRequests(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getExpiredRequests')
        .then(res=>{
            return res.data;
        })
    }

    async getExpiredRequestsHr(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getExpiredRequestsHr')
        .then(res=>{
            return res.data;
        })
    }

    async searchByName(req:RequestByName): Promise<CommonResponse> {
        console.log(req,"request")
        return await axios.post(this.URL + '/searchByName',req)
        .then(res => {
            return res.data;
        })
    }

    async getByDate(req:RequestReport):Promise<CommonResponse> {
        return await axios.post(this.URL + '/getByDate',req)
        .then(res => {
            return res.data;
        })
    }

    async visitorCount(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/visitorCount')
        .then(res=>{
            return res.data;
        })
    }

    async todayVisitors(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/todayVisitors')
        .then(res=>{
            return res.data;
        })
    }

    async todayRequests(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/todayRequests')
        .then(res=>{
            return res.data;
        })
    }

    async hodCount(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/hodCount')
        .then(res=>{
            return res.data;
        })
    }

    async hrCount(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/hrCount')
        .then(res=>{
            return res.data;
        })
    }

    async visitorMonthWiseCount(): Promise<CommonResponse> {
        return await axios.post(this.URL + '/visitorMonthWiseCount')
        .then(res=>{
            return res.data;
        })
    }

    async getDateReport(req: RequestReport) : Promise<CommonResponse> {
        return await axios.post(this.URL + '/getDateReport',req)
        .then(res => {
            return res.data;
        })
    }

}